<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
      <el-form-item label="课程名称" prop="courseName">
        <el-input v-model="dataForm.courseName" placeholder="课程名称"></el-input>
      </el-form-item>
      <el-form-item label="上架状态" prop="status">
        <el-radio v-model="dataForm.status" :label="0">下架</el-radio>
        <el-radio v-model="dataForm.status" :label="1">上架</el-radio>
      </el-form-item>
      <el-form-item label="课程简介" prop="introduction">
        <el-input v-model="dataForm.introduction" placeholder="课程简介"></el-input>
      </el-form-item>
      <el-form-item label="分类" prop="typeId">
        <el-select v-model="dataForm.typeId" placeholder="分类" clearable>
        <el-option v-for="type in courseTypeList"
                   :label="type.typeName"
                   :value="type.id"
                   :key="type.id" >
        </el-option>
      </el-select>
      </el-form-item>
      <el-form-item label="观看得分" prop="score">
        <el-input v-model="dataForm.score" placeholder="观看得分"></el-input>
      </el-form-item>
      <el-form-item label="封面图片" prop="imgSrc">
        <el-upload
                class="avatar-uploader"
                :action="uploadUrl"
                :show-file-list="false"
                :on-success="uploadSuccessHandle"
                :before-upload="uploadBeforeUploadHandle">
          <img v-if="dataForm.imgSrc" :src="dataForm.imgSrc" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="排序" prop="weight">
        <el-input-number v-model="dataForm.weight" :min="1" label="排序"></el-input-number>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import Cookies from 'js-cookie'
export default {
  data () {
    return {
      uploadUrl: '',
      visible: false,
      courseTypeList: [],
      dataForm: {
        id: '',
        courseName: '',
        status: 0,
        typeId: '',
        score: '',
        viewNum: '',
        thumbNum: '',
        commentTableId: '',
        weight: '',
        creator: '',
        updater: '',
        createDate: '',
        updateDate: '',
        schoolId: '',
        imgSrc: '',
        introduction: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        courseName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        introduction: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        typeId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        score: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.uploadUrl = `${window.SITE_CONFIG.apiURL}/sys/oss/upload?token=${Cookies.get('token')}`
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 上传图片之前
    uploadBeforeUploadHandle (file) {
      if (file.type !== 'image/jpg' && file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/gif') {
        this.$message.error(this.$t('upload.tip', { format: 'jpg、png、gif' }))
        return false
      }
    },
    // 上传图片成功
    uploadSuccessHandle (res, file, fileList) {
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      }
      this.dataForm.imgSrc = res.data.src
      console.log(this.dataForm.imgSrc)
    },
    // 获取信息
    getInfo () {
      this.$http.get('/parentStarLicense/onlineCourse/' + this.dataForm.id).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    getCourseTypeList () {
      this.$http.get('/parentStarLicense/courseType/getList').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.courseTypeList = res.data
        console.log(this.courseTypeList)
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      // 两位位小数的正则表达式
      const r = /^([0-9]\d*(\.\d{1,2})?|([0](\.([0][1-9]|[1-9]\d{0,1}))))$/
      if (!r.test(this.dataForm.score)) {
        return this.$message.error('积分最多支持小数点后两位')
      }
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/parentStarLicense/onlineCourse/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { leading: true, trailing: false })
  },
  mounted () {
    this.getCourseTypeList()
  }
}
</script>
